module.exports = __webpack_public_path__ + "static/media/Smeargle_gaussian2.0b404814.png";